import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FiHelpCircle, FiSearch, FiMessageCircle, FiBookOpen } from 'react-icons/fi';

const HelpCenter = () => {
  const faqs = [
    { q: "How do I join a match?", a: "Find a match on the Discover page, click View, and then click Join Match. You'll need to be logged in." },
    { q: "Can I host my own games?", a: "Yes! Use the 'Create Match' button in the navigation to host your own game for others to join." },
    { q: "Is there a fee for using PlayConnect?", a: "PlayConnect is free to use for organizing and finding matches. Any venue fees are handled at the location." },
    { q: "How do I report a player?", a: "You can report players through their profile page or contact our support team directly." }
  ];

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <FiHelpCircle className="mx-auto text-red-500 mb-6" size={64} />
          <h1 className="text-4xl font-bold text-white mb-4">How can we help?</h1>
          <div className="relative max-w-lg mx-auto">
            <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
            <input 
              type="text" 
              placeholder="Search for help topics..." 
              className="w-full bg-gray-900 border border-gray-800 text-white rounded-xl pl-12 pr-4 py-4 outline-none focus:border-red-500 transition"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800 hover:border-red-500/50 transition">
            <FiBookOpen className="text-red-500 mb-4" size={32} />
            <h3 className="text-xl font-bold text-white mb-2">Guides & Basics</h3>
            <p className="text-gray-400 text-sm">Learn the fundamentals of using PlayConnect to find and host matches.</p>
          </div>
          <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800 hover:border-red-500/50 transition">
            <FiMessageCircle className="text-red-500 mb-4" size={32} />
            <h3 className="text-xl font-bold text-white mb-2">Support Chat</h3>
            <p className="text-gray-400 text-sm">Need direct help? Our community moderators are available 24/7.</p>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-white mb-8 border-b border-gray-800 pb-4">Frequently Asked Questions</h2>
        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-gray-900/50 p-6 rounded-xl border border-gray-800">
              <h4 className="text-white font-semibold mb-2">{faq.q}</h4>
              <p className="text-gray-400 text-sm leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HelpCenter;
